<template>
  <a-modal
      title="绑定衣袋信息"
      :width="640"
      v-model="visible"
      :confirm-loading="confirmLoading"
      :bodyStyle="{ maxHeight: '700px', overflowY: 'auto' }"
  >
    <a-form :form="form">
      <a-form-item
          label="衣袋号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          hasFeedback
      >
        <a-input
            v-decorator="['pocketNo', { rules: [{ required: true, message: '请输入衣袋号!' }] }]"
            placeholder="请输入衣袋号"
        />
      </a-form-item>

      <a-form-item
          label="硅胶标签一"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          hasFeedback
      >
        <a-input
            v-decorator="['labelNo1', { rules: [{ required: false }] }]"
            placeholder="请输入硅胶标签一"
        />
      </a-form-item>

      <a-form-item
          label="硅胶标签二（可删除）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          hasFeedback
      >
        <a-input
            v-decorator="['labelNo2', { rules: [{ required: false }] }]"
            placeholder="请输入硅胶标签二"
        />
      </a-form-item>

      <a-form-item
          label="硅胶标签三"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          hasFeedback
      >
        <a-input
            v-decorator="['labelNo3', { rules: [{ required: false }] }]"
            placeholder="请输入硅胶标签三"
        />
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleSubmit">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import userService from '@/service/user.js'

export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      formData: {}
    }
  },
  methods: {
    showForm(formData) {
      this.visible = true
      this.formData = formData
      this.$nextTick(() => {
        this.form.setFieldsValue({
          pocketNo: formData.pocketNo || '',
          labelNo1: (formData.labelNos && formData.labelNos[0]) || '',
          labelNo2: (formData.labelNos && formData.labelNos[1]) || '',
          labelNo3: (formData.labelNos && formData.labelNos[2]) || ''
        })
      })
    },

    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // 验证至少填写一个标签
          if (!values.labelNo1 && !values.labelNo2 && !values.labelNo3) {
            this.$message.error('至少填写一个硅胶标签')
            return
          }
          this.confirmLoading = true

          // 处理标签数据
          const labelNos = [
            values.labelNo1,
            values.labelNo2,
            values.labelNo3
          ].filter(label => label && label.trim() !== '')

          // 构造提交数据
          const submitData = {
            id: this.formData.id,
            pocketNo: values.pocketNo,
            labelNos: labelNos
          }

          userService.editPocketBind(submitData).then(res => {
            this.confirmLoading = false
            this.visible = false
            this.$message.success('提交成功')
            this.formData.pocketNo = submitData.pocketNo
            this.formData.labelNos = submitData.labelNos
          }).catch(err => {
            this.confirmLoading = false
          })
        }
      })
    },

    handleCancel() {
      this.visible = false
    }
  }
}
</script>